import {connect} from 'react-redux';
import {get} from 'lodash/fp';
import {createStructuredSelector} from 'reselect';

import {
  fetchmyWhy,
  fetchplanDetails,
  fetchstartDate,
} from '/redux/action/client.action';
import {
  clientmyWhy,
  clientPlanDetails,
  clientStartDate,
  firstNameById,
} from '/redux/selector/client.selector';
import {fromProps, withProps} from '/util/selector.util';

import HealthJourney from './HealthJourney';

interface MWLData {
  data: {
    myPlan?: string;
    startDate?: string;
    myWhy?: string;
  };
}
const withClientId = withProps({
  clientId: fromProps(get('recordId')),
});

const mapStateToProps = createStructuredSelector({
  clientStartDate: withClientId(clientStartDate),
  clientPlanDetails: withClientId(clientPlanDetails),
  clientmyWhy: withClientId(clientmyWhy),
  firstName: firstNameById,
});

const mapDispatchToProps = (dispatch: any) => ({
  fetchstartDate: ({clientId}: any) => dispatch(fetchstartDate({clientId})),
  fetchplanDetails: ({clientId}: any) => dispatch(fetchplanDetails({clientId})),
  fetchmyWhy: ({clientId}: any) => dispatch(fetchmyWhy({clientId})),
});
const mergeProps = (stateProps: any, dispatchProps: any, ownProps: any) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,

  fetchstartDate: async (mwldata: MWLData, clientId: string) => {
    const {startDate} = mwldata.data || {};
    await Promise.resolve().then(() =>
      startDate ? dispatchProps.fetchstartDate({clientId}) : Promise.resolve(),
    );
  },
  fetchplanDetails: async (mwldata: MWLData, clientId: string) => {
    const {myPlan} = mwldata.data || {};
    await Promise.resolve().then(() =>
      myPlan ? dispatchProps.fetchplanDetails({clientId}) : Promise.resolve(),
    );
  },
  fetchmyWhy: async (mwldata: MWLData, clientId: string) => {
    const {myWhy} = mwldata.data || {};
    await Promise.resolve().then(() =>
      myWhy ? dispatchProps.fetchmyWhy({clientId}) : Promise.resolve(),
    );
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(HealthJourney);
